<template>
    <div style="background: #F5F7FA; padding: 24px 16px 60px;">
        <div style="max-width: 520px; margin: 0 auto;">
            <!-- Header -->
            <div class="text-center" style="margin-bottom: 32px;">
                <div style="display: inline-block; background: #1B2557; color: #fff; padding: 4px 16px; border-radius: 16px; font-size: 12px; font-weight: 600; letter-spacing: 1px; margin-bottom: 16px;">
                    2026 여름방학
                </div>
                <h1 style="font-size: 28px; font-weight: 800; color: #1A1A1A; letter-spacing: -0.5px; margin-bottom: 8px;">
                    부트캠프 문의하기
                </h1>
                <p style="font-size: 14px; color: #4A4A4A; line-height: 1.6;">
                    AP CSA 여름 부트캠프에 관심을 가져주셔서 감사합니다.<br/>
                    아래 정보를 입력해주시면 개별 연락드리겠습니다.
                </p>
            </div>

            <!-- Form Card -->
            <v-card flat style="border-radius: 16px; padding: 32px; border: 1px solid #E8ECF0;">
                <v-form v-model="valid">
                    <!-- 이름 -->
                    <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 6px;">이름</div>
                    <v-text-field
                            dense outlined
                            placeholder="학생 또는 학부모 이름"
                            v-model="parentName"
                            :rules="[rules.required]"
                            hide-details="auto"
                            style="margin-bottom: 20px;"
                    ></v-text-field>

                    <!-- 전화번호 -->
                    <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 6px;">전화번호</div>
                    <v-row no-gutters style="margin-bottom: 20px;">
                        <v-col cols="4" style="padding-right: 8px;">
                            <v-autocomplete
                                    dense outlined
                                    placeholder="국가코드"
                                    :items="countryCodes"
                                    v-model="parentCountryCode"
                                    :rules="[rules.required]"
                                    hide-details="auto"
                                    auto-select-first
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field
                                    dense outlined
                                    placeholder="'-' 없이 번호만 입력"
                                    v-model="parentPhone"
                                    :rules="[rules.required]"
                                    hide-details="auto"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <!-- 이메일 -->
                    <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 6px;">이메일</div>
                    <v-text-field
                            dense outlined
                            placeholder="email@example.com"
                            v-model="email"
                            :rules="[rules.required]"
                            hide-details="auto"
                            style="margin-bottom: 20px;"
                    ></v-text-field>

                    <!-- 학년 -->
                    <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 6px;">학년 (2026년 기준)</div>
                    <v-select
                            dense outlined
                            placeholder="학년 선택"
                            :items="grades"
                            v-model="studentGrade"
                            :rules="[rules.required]"
                            hide-details="auto"
                            style="margin-bottom: 20px;"
                    ></v-select>

                    <!-- 신청 프로그램 -->
                    <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 6px;">신청 프로그램</div>
                    <v-select
                            dense outlined
                            placeholder="프로그램 선택"
                            :items="programs"
                            v-model="selectedProgram"
                            :rules="[rules.required]"
                            hide-details="auto"
                            style="margin-bottom: 20px;"
                    ></v-select>

                    <!-- 신청 이유 -->
                    <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 6px;">부트캠프 신청 이유</div>
                    <v-textarea
                            outlined
                            placeholder="신청 동기를 간단히 작성해주세요"
                            v-model="applyReason"
                            :rules="[rules.required]"
                            hide-details="auto"
                            rows="3"
                            style="margin-bottom: 20px;"
                    ></v-textarea>

                    <!-- 유입경로 -->
                    <div style="font-size: 13px; font-weight: 600; color: #1A1A1A; margin-bottom: 6px;">IVYED를 어떻게 알게 되셨나요?</div>
                    <v-select
                            dense outlined
                            placeholder="선택"
                            :items="channels"
                            v-model="channel"
                            :rules="[rules.required]"
                            hide-details="auto"
                            style="margin-bottom: 28px;"
                    ></v-select>

                    <!-- 안내 -->
                    <div style="font-size: 12px; color: #999; margin-bottom: 20px; line-height: 1.6;">
                        * 소수정예로 운영되며 신청서를 토대로 개별 연락드리고 있습니다.
                    </div>

                    <!-- Submit -->
                    <v-btn
                            block large
                            color="#EF0006"
                            style="font-weight: 700; font-size: 16px; letter-spacing: -0.5px; border-radius: 10px; height: 52px; color: white;"
                            @click="sendEmailAndMoveToSuccessPage"
                    >
                        신청서 제출하기
                    </v-btn>
                </v-form>
            </v-card>

            <!-- Back link -->
            <div class="text-center" style="margin-top: 20px;">
                <v-btn text small color="#4A4A4A" to="/bootcamp/apcsa">
                    <v-icon left small>mdi-arrow-left</v-icon>
                    부트캠프 페이지로 돌아가기
                </v-btn>
            </div>
        </div>

        <v-snackbar v-model="snackbar" top>
            {{ text }}
            <template v-slot:action="{ attrs }">
                <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
    import info from "../../../info";
    import config from "../../../config";
    import emailjs from "emailjs-com";

    export default {
        name: "BootcampRegister2026",
        data() {
            return {
                countryCodes: info.countryCodes,
                programs: info.bootCampPrograms,
                grades: info.newGradesList,
                channels: info.channelList,
                parentName: '',
                email: '',
                parentCountryCode: '',
                parentPhone: '',
                studentGrade: '',
                selectedProgram: '',
                applyReason: '',
                channel: '',
                snackbar: false,
                text: '신청이 접수 되었습니다.',
                valid: false,
                rules: {
                    required: (value) => !!value || '필수 입력',
                },
            }
        },
        methods: {
            sendEmail() {
                var message = "이름: " + this.parentName + ", 휴대전화: " + this.parentCountryCode + " " + this.parentPhone + ", 학년: " + this.studentGrade + ", 유입경로: " + this.channel + ", 이메일: " + this.email + ", 신청 프로그램: " + this.selectedProgram + ", 신청 이유: " + this.applyReason;

                var obj = {
                    user_email: this.parentName,
                    from_name: "Bootcamp 신청 from " + this.parentName + ": " + this.parentCountryCode + " " + this.parentPhone,
                    message_html: message,
                    to_name: "IVYED",
                };

                emailjs.send(
                    config.emailjs.serviceID,
                    config.emailjs.templateID,
                    obj,
                    config.emailjs.userID
                ).then(
                    () => {
                        this.snackbar = true;
                    },
                    () => {
                        this.snackbar = true;
                        this.text = "오류가 발생했습니다. 다시 시도해주세요.";
                    }
                );
            },
            sendEmailAndMoveToSuccessPage() {
                if (!this.parentName || !this.parentPhone || !this.email) {
                    this.snackbar = true;
                    this.text = '이름, 전화번호, 이메일은 필수 입력입니다.';
                    return;
                }
                this.sendEmail();
                this.$router.push("/bootcamp/apcsa/register/confirmed");
            },
        }
    }
</script>
